function ensureUnique(arr) {
  return arr.filter((el, idx) => arr.indexOf(el) === idx);
}
function getTeamFromHierarchy(team, targetTeamId) {
  if (team.id === targetTeamId) {
    return team;
  }
  return team.childTeams.reduce((acc, childTeam) => {
    const result = getTeamFromHierarchy(childTeam, targetTeamId);
    if (result) {
      return result;
    }
    return acc;
  }, null);
}
const getTeam = (teams, targetTeamId) => {
  return teams.reduce((acc, team) => {
    if (!acc) {
      const result = getTeamFromHierarchy(team, targetTeamId);
      if (result) {
        return result;
      }
    }
    return acc;
  }, null);
};
function getAllChildTeamIds(team) {
  return team.childTeams.reduce((acc, childTeam) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return acc.concat([childTeam.id]).concat(getAllChildTeamIds(childTeam));
  }, []);
}
export const getAllTeamIds = teams => {
  return teams.reduce((acc, team) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return acc.concat([team.id]).concat(getAllChildTeamIds(team));
  }, []);
};
function _getAllParentTeamIdsFromHierarchy(parentIds, team, targetTeamId) {
  if (team.id === targetTeamId) {
    return parentIds;
  }
  return team.childTeams.reduce((acc, childTeam) => {
    const result = _getAllParentTeamIdsFromHierarchy(parentIds.concat([team.id]), childTeam, targetTeamId);
    if (result) {
      return result;
    }
    return acc;
  }, null);
}
const getAllParentTeamIdsFromHierarchy = (team, targetTeamId) => _getAllParentTeamIdsFromHierarchy([], team, targetTeamId);
const getAllParentTeamIds = (teams, targetTeamId) => {
  return teams.reduce((acc, team) => {
    if (!acc) {
      const result = getAllParentTeamIdsFromHierarchy(team, targetTeamId);
      if (result) {
        return result;
      }
    }
    return acc;
  }, null);
};
export const toggleSelectedTeam = (selectedTeams, allTeams, teamId) => {
  const isSelected = selectedTeams.includes(teamId);
  let updatedSelectedTeams;
  if (!isSelected) {
    const allParentTeamIds = getAllParentTeamIds(allTeams, teamId);
    updatedSelectedTeams = selectedTeams.concat([teamId]).concat(allParentTeamIds || []);
  } else {
    const team = getTeam(allTeams, teamId);
    if (!team) {
      /*
       The UI only renders the teams in `allTeams`, so this should not occur.
       If team (with id `teamId`) was deleted from the portal, the UI doesn't
       display a checkbox for it.
       */
      console.error(`Team with teamId '${teamId}' not found`);
      return selectedTeams;
    }
    const childTeamIds = getAllChildTeamIds(team);
    updatedSelectedTeams = selectedTeams.filter(id => id !== teamId && !childTeamIds.includes(id));
  }
  return ensureUnique(updatedSelectedTeams);
};
const getAllUserIdsInHierarchy = (teamHierarchy, selectedTeamIds) => {
  let currentTeamUserIds = [];
  if (!selectedTeamIds || selectedTeamIds && selectedTeamIds.includes(teamHierarchy.id)) {
    currentTeamUserIds = [...teamHierarchy.userIds];
  }
  if (!teamHierarchy.childTeams.length) {
    return currentTeamUserIds;
  }
  return teamHierarchy.childTeams.reduce((acc, team) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return acc.concat(getAllUserIdsInHierarchy(team, selectedTeamIds));
  }, currentTeamUserIds);
};
export const getAllUserIdsFromTeams = (teams, selectedTeamIds) => {
  return ensureUnique(teams.reduce((acc, team) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return acc.concat(getAllUserIdsInHierarchy(team, selectedTeamIds));
  }, []));
};
export const areOnlyChildTeams = teams => {
  return teams.reduce((_, team) => {
    if (!team.childTeams || !team.childTeams.length) {
      return true;
    }
    return false;
  }, true);
};